import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ProductListService } from '../../product-list.service';
import { ArtistService } from '../../artist.service';

@Component({
  selector: 'pv-store-toolbar',
  templateUrl: './store-toolbar.component.html',
  styleUrls: ['./store-toolbar.component.scss']
})
export class StoreToolbarComponent implements OnInit {
  @Input() padding?: boolean;
  showAll = false;
  artists: { url_alias: string, id: number, name: string, status: string }[]
  showArtists: { url_alias: string, id: number, name: string, status: string }[]

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private artistService: ArtistService,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (params.url_alias == 'non_polyvinyl') {
        this.showAll = true;
      }
      if (this.artists && this.showAll) {
        this.showArtists = this.artists;
      }
    })

    this.artistService.getArtistStoreList()
    .subscribe(artists => {
      this.artists = artists
      this.showArtists = artists
    })
  }


  onChange(event) {
    this.router.navigate(event ? ['/store', event.url_alias] : ['/store'])
  }
}
